import React from "react";
import BaseTitleChart from "../../sisu/title/BaseTitleChart.sisu";

const NeoTitleChart = (props) => {
  return (<BaseTitleChart custom="titulo-grafica" {...props}>
    {props.children}
  </BaseTitleChart >);
};

export default NeoTitleChart;